import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Row, Col, Input, Label, FormGroup } from "reactstrap";
import axios from "axios";

const CustomFieldsForm = forwardRef(({
 courseId,
 postulationBasisId,
 stageId,
 customFields = [],
 setApplicanttHit,
 showNotification,
 initialValues = {}
}, ref) => {
  const [formData, setFormData] = useState(() => {
    return Array.isArray(customFields)
      ? customFields.reduce((acc, field) => ({
        ...acc,
        [field.name]: initialValues?.[field.name] || ""
      }), {})
      : {};
  });

  useEffect(() => {
    if (Array.isArray(customFields)) {
      setFormData(customFields.reduce((acc, field) => ({
        ...acc,
        [field.name]: initialValues?.[field.name] || ""
      }), {}));
    }
  }, [initialValues, customFields]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.put(`/api/courses/${courseId}/postulation_bases/${postulationBasisId}/stage_bases/${stageId}/update_custom_fields`, {
        stage: { custom_fields_data: formData }
      }, {
        headers: { "X-CSRF-TOKEN": window.Hupe8.token }
      });

      if (response.data.success) {
        showNotification("Genial", "Campos guardados con éxito!", "success");
      }
    } catch (error) {
      showNotification("Ops", "Hubo un error al guardar los campos!", "danger");
    }
  };

  useImperativeHandle(ref, () => ({
    saveCustomFields: handleSubmit
  }));

  return (
    <Row>
      <Col md="12">
        <h5 className="fw-bold text-muted">Datos adicionales</h5>
        {Array.isArray(customFields) && customFields.length > 0 ? (
          customFields.map((field, index) => (
            <FormGroup key={index}>
              <Label>{field.label}</Label>
              {field.type === "text" && <Input type="text" name={field.name} value={formData[field.name] || ""} onChange={handleChange} />}
              {field.type === "date" && <Input type="date" name={field.name} value={formData[field.name] || ""} onChange={handleChange} />}
              {field.type === "checkbox" && <Input type="checkbox" name={field.name} checked={formData[field.name] || false} onChange={handleChange} />}
              {field.type === "textarea" && <Input type="textarea" name={field.name} value={formData[field.name] || ""} onChange={handleChange} />}
              {field.description && <small className="text-muted">{field.description}</small>}
            </FormGroup>
          ))
        ) : (
          <p>No hay campos personalizados para mostrar.</p>
        )}
      </Col>
    </Row>
  );
});

export default CustomFieldsForm;
